import { Box, Grid, Paper, Tabs, Tab, useTheme } from "@mui/material";
import React, { useState, useEffect } from "react";
import { NavLink, Outlet, useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

const tabStyle = {
  textTransform: "capitalize",
  fontWeight: "bold",
  borderRadius: "10px",
};

const FinancialManagerNav = () => {
  const theme = useTheme();
  const { t } = useTranslation();
  const [value, setValue] = useState("/financial-manager");
  const navigate = useNavigate();
  const location = useLocation();

  const handleChange = (event, newValue) => {
    setValue(newValue);
    navigate(newValue);
  };

  useEffect(() => {
    const path = location.pathname;
    const validPaths = [
      "/financial-manager",
      "/financial-manager/payroll",
      "/financial-manager/advance",
      "/financial-manager/bonus",
      "/financial-manager/expenses-type",
      "/financial-manager/expense-source",
      "/financial-manager/expenses",
      "/financial-manager/expense-payments",
      "/financial-manager/medicine-payment",
      "/financial-manager/invoices",
      "/financial-manager/payments",
    ];

    if (validPaths.includes(path)) {
      setValue(path);
    } else if (path.startsWith("/financial-manager/invoices")) {
      setValue("/financial-manager/invoices");
    } else if (path.startsWith("/financial-manager/payments")) {
      setValue("/financial-manager/payments");
    } else if (path.startsWith("/financial-manager/medicine-payment")) {
      setValue("/financial-manager/medicine-payment");
    } else if (path.startsWith("/financial-manager/expense-payments")) {
      setValue("/financial-manager/expense-payments");
    } else if (path.startsWith("/financial-manager/expenses-type")) {
      setValue("/financial-manager/expenses-type");
    } else if (path.startsWith("/financial-manager/expense-source")) {
      setValue("/financial-manager/expense-source");
    } else if (path.startsWith("/financial-manager/expenses")) {
      setValue("/financial-manager/expenses");
    } else {
      setValue("/financial-manager");
    }
  }, [location.pathname]);

  return (
    <Grid container maxWidth="xl">
      <Box sx={{ width: "100%", bgcolor: "background.paper" }}>
        <Paper sx={{ padding: "10px 0px", boxShadow: "0px 0px 0px" }}>
          <Tabs
            value={value}
            onChange={handleChange}
            variant="scrollable"
            scrollButtons="auto"
            allowScrollButtonsMobile
            sx={{
              ml: "5px",
              "& .MuiTabs-indicator": { display: "none" },
              "& .MuiTab-root": { minWidth: "120px" },
            }}
          >
            <Tab
              style={{
                ...tabStyle,
                backgroundColor:
                  value === "/financial-manager"
                    ? theme.palette.primary.main
                    : "white",
                color:
                  value === "/financial-manager" ? "white" : "black",
              }}
              label={t("finance.dashboard")}
              value="/financial-manager"
              component={NavLink}
              to="/financial-manager"
            />
            <Tab
              style={{
                ...tabStyle,
                backgroundColor:
                  value === "/financial-manager/payroll"
                    ? theme.palette.primary.main
                    : "white",
                color:
                  value === "/financial-manager/payroll" ? "white" : "black",
              }}
              label={t("finance.payroll")}
              value="/financial-manager/payroll"
              component={NavLink}
              to="/financial-manager/payroll"
            />
            <Tab
              style={{
                ...tabStyle,
                backgroundColor:
                  value === "/financial-manager/advance"
                    ? theme.palette.primary.main
                    : "white",
                color:
                  value === "/financial-manager/advance" ? "white" : "black",
              }}
              label={t("finance.managerAdvance", "Advance")}
              value="/financial-manager/advance"
              component={NavLink}
              to="/financial-manager/advance"
            />
            <Tab
              style={{
                ...tabStyle,
                backgroundColor:
                  value === "/financial-manager/bonus"
                    ? theme.palette.primary.main
                    : "white",
                color: value === "/financial-manager/bonus" ? "white" : "black",
              }}
              label={t("finance.bonus")}
              value="/financial-manager/bonus"
              component={NavLink}
              to="/financial-manager/bonus"
            />
            <Tab
              style={{
                ...tabStyle,
                backgroundColor:
                  value === "/financial-manager/expenses-type"
                    ? theme.palette.primary.main
                    : "white",
                color:
                  value === "/financial-manager/expenses-type"
                    ? "white"
                    : "black",
              }}
              label={t("finance.expenseType")}
              value="/financial-manager/expenses-type"
              component={NavLink}
              to="/financial-manager/expenses-type"
            />
            <Tab
              style={{
                ...tabStyle,
                backgroundColor:
                  value === "/financial-manager/expense-source"
                    ? theme.palette.primary.main
                    : "white",
                color:
                  value === "/financial-manager/expense-source"
                    ? "white"
                    : "black",
              }}
              label={t("finance.expenseSource")}
              value="/financial-manager/expense-source"
              component={NavLink}
              to="/financial-manager/expense-source"
            />
            <Tab
              style={{
                ...tabStyle,
                backgroundColor:
                  value === "/financial-manager/expenses"
                    ? theme.palette.primary.main
                    : "white",
                color:
                  value === "/financial-manager/expenses" ? "white" : "black",
              }}
              label={t("finance.expenses")}
              value="/financial-manager/expenses"
              component={NavLink}
              to="/financial-manager/expenses"
            />
            <Tab
              style={{
                ...tabStyle,
                backgroundColor:
                  value === "/financial-manager/expense-payments"
                    ? theme.palette.primary.main
                    : "white",
                color:
                  value === "/financial-manager/expense-payments"
                    ? "white"
                    : "black",
              }}
              label={t("finance.managerExpensePayment", "Expense Payment")}
              value="/financial-manager/expense-payments"
              component={NavLink}
              to="/financial-manager/expense-payments"
            />
            <Tab
              style={{
                ...tabStyle,
                backgroundColor:
                  value === "/financial-manager/medicine-payment"
                    ? theme.palette.primary.main
                    : "white",
                color:
                  value === "/financial-manager/medicine-payment"
                    ? "white"
                    : "black",
              }}
              label={t("finance.medicinePayment")}
              value="/financial-manager/medicine-payment"
              component={NavLink}
              to="/financial-manager/medicine-payment"
            />
            <Tab
              style={{
                ...tabStyle,
                backgroundColor:
                  value === "/financial-manager/invoices"
                    ? theme.palette.primary.main
                    : "white",
                color:
                  value === "/financial-manager/invoices" ? "white" : "black",
              }}
              label={t("finance.invoices", "Invoices")}
              value="/financial-manager/invoices"
              component={NavLink}
              to="/financial-manager/invoices"
            />
            <Tab
              style={{
                ...tabStyle,
                backgroundColor:
                  value === "/financial-manager/payments"
                    ? theme.palette.primary.main
                    : "white",
                color:
                  value === "/financial-manager/payments" ? "white" : "black",
              }}
              label={t("finance.payments", "Payments")}
              value="/financial-manager/payments"
              component={NavLink}
              to="/financial-manager/payments"
            />
          </Tabs>
        </Paper>
      </Box>
      <Outlet />
    </Grid>
  );
};

export default FinancialManagerNav;
